// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container */
.price-returns-dashboard {
  background-color: white;
  min-height: 100vh;
  padding: 1.5rem;
  font-family: 'Roboto Mono', monospace;
}

/* Title container */
.price-returns-dashboard-title {
  font-family: 'Roboto Mono', monospace;
  font-size: 1.75rem;
  font-weight: 400;
  color: black;
  margin-bottom: 1rem;
  text-align: center;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100vw - 10rem);
  max-width: 100%;
}

/* Dashboard layout */
.price-returns-dashboard-layout {
  max-width: 1880px;
  margin: 0 auto;
  background: white;
  border-radius: 0;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: none;
  display: flex;
  gap: 10px;
  height: fit-content;
}

/* Timeframe selector */
.price-returns-timeframe-selector {
  display: flex;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid black;
}

.price-returns-timeframe-button {
  font-family: 'Roboto Mono', monospace;
  padding: 0.5rem 1rem;
  font-weight: 400;
  font-size: 0.875rem;
  color: black;
  border: none;
  background: none;
  cursor: pointer;
}

.price-returns-timeframe-button:hover {
  color: black;
}

.price-returns-timeframe-button.price-returns-active {
  color: black;
  font-weight: 500;
  border-bottom: 2px solid black;
}

/* Chart section */
.price-returns-chart-section {
  height: 920px;
  font-family: 'Roboto Mono', monospace;
  border: none;
  box-shadow: none;
  flex: 1.45 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: visible;
  border: 1px black solid;
}

.price-returns-chart-section h3 {
  font-size: 1.25rem;
  font-weight: 400;
  color: black;
  margin-bottom: 1rem;
  text-align:center;
}

/* Summary section */
.price-returns-summary-section {
  padding-top: 0px;
  padding-right: 10px;
  padding-bottom: 40px;
  overflow: visible;
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  height: 920px;
}

.price-returns-summary-table-container {
  flex: 1 1;
  overflow-y: hidden;
  min-height: 0;
  background: white;
  box-shadow: none;
  outline: 0.25px solid black;
  border: none;
  height: 920px;
}

.price-returns-summary-table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Roboto Mono', monospace;
  font-size: 0.85rem;
}

.price-returns-summary-table thead {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
}

.price-returns-summary-table th {
  padding: 0.5rem 1rem;
  text-align: left;
  font-size: 0.85rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: black;
  background-color: white;
  border-bottom: 1px solid black;
}

.price-returns-summary-table td {
  padding: 0.5rem 1rem;
  white-space: nowrap;
  font-size: 0.85rem;
}

.price-returns-summary-table th:first-child,
.price-returns-summary-table td:first-child {
  text-align: left;
  color: black;
  font-weight: 400;
  border-right: 1px solid black;
}

.price-returns-summary-table td {
  transition: background-color 0.2s ease;
}

.price-returns-summary-table td.price-returns-positive {
  color: #28a745;
  background-color: rgba(40, 167, 69, 0.1);
}

.price-returns-summary-table td.price-returns-negative {
  color: #dc3545;
  background-color: rgba(220, 53, 69, 0.1);
}

.price-returns-summary-table td.price-returns-active {
  font-weight: 400;
}

.price-returns-summary-table tbody tr:hover td.price-returns-positive {
  background-color: rgba(40, 167, 69, 0.1);
}

.price-returns-summary-table tbody tr:hover td.price-returns-negative {
  background-color: rgba(220, 53, 69, 0.1);
}

/* Sector tables */
.price-returns-sector-tables {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
  padding: 1.5rem 0;
}

.price-returns-sector-table {
  background: white;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  padding: 1.25rem;
  border: 1px solid black;
  font-family: 'Roboto Mono', monospace;
}

.price-returns-sector-table h3 {
  font-size: 1rem;
  font-weight: 400;
  color: #1f2937;
  margin-bottom: 0.75rem;
  text-align: center;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e0e0e0;
}

.price-returns-returns-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.price-returns-returns-table th,
.price-returns-returns-table td {
  padding: 6px 8px;
  text-align: left;
  border-bottom: 1px solid #eee;
  font-size: 0.813rem;
}

.price-returns-returns-table th {
  color: black;
  font-weight: normal;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.price-returns-returns-table th:hover {
  background-color: #e9ecef;
}

.price-returns-returns-table tr:hover:not(.price-returns-category-total) {
  background-color: #f8f9fa;
}

/* Utility classes */
.price-returns-positive {
  color: #28a745;
}

.price-returns-negative {
  color: #dc3545;
}

.price-returns-category-total {
  font-weight: 600;
  background-color: #f8f9fa;
}

.price-returns-sort-indicator {
  display: inline-block;
  margin-left: 4px;
  font-size: 12px;
}

/* Loading and error states */
.price-returns-loading,
.price-returns-error {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 18px;
}

.price-returns-loading {
  color: #666;
}

.price-returns-error {
  color: #dc3545;
}

/* Chart styles */
.price-returns-dashboard .recharts-cartesian-grid line {
  stroke: #eee;
}

.price-returns-dashboard .recharts-text {
  font-family: 'Roboto Mono', monospace;
  font-size: 12px;
  fill: black;
}

.price-returns-dashboard .recharts-responsive-container {
  width: 100% !important;
  height: 100% !important;
  overflow: visible !important;
}

/* Responsive */
@media (max-width: 1200px) {
  .price-returns-dashboard-layout {
    flex-direction: column;
  }
  
  .price-returns-chart-section,
  .price-returns-summary-section {
    width: 100%;
    min-height: 300px;
  }
}

@media (max-width: 768px) {
  .price-returns-sector-tables {
    grid-template-columns: 1fr;
  }
}

.price-returns-logo-link {
  text-decoration: none;
  margin-left: 0;  /* Ensure no left margin */
  padding-left: 0; /* Ensure no left padding */
}

.price-returns-logo.asxn-logo {
  text-align: left;  /* Ensure left alignment */
  margin-left: 0;    /* Remove any margin */
  padding-left: 0;   /* Remove any padding */
}

/* Last Updated Time */
.price-returns-last-updated {
  text-align: center;
  color: #888;
  font-size: 0.8rem;
  margin-top: 20px;
  margin-bottom: 10px;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/styles/price_returns_dashboard.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,qCAAqC;AACvC;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;EAChB,YAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,qBAAqB;EACrB,cAAc,GAAG,0BAA0B;EAC3C,eAAe,EAAE,2BAA2B;AAC9C;;AAEA;EACE,gBAAgB,GAAG,0BAA0B;EAC7C,cAAc,KAAK,sBAAsB;EACzC,eAAe,IAAI,uBAAuB;AAC5C;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* Main container */\n.price-returns-dashboard {\n  background-color: white;\n  min-height: 100vh;\n  padding: 1.5rem;\n  font-family: 'Roboto Mono', monospace;\n}\n\n/* Title container */\n.price-returns-dashboard-title {\n  font-family: 'Roboto Mono', monospace;\n  font-size: 1.75rem;\n  font-weight: 400;\n  color: black;\n  margin-bottom: 1rem;\n  text-align: center;\n  position: relative;\n  left: 50%;\n  transform: translateX(-50%);\n  width: calc(100vw - 10rem);\n  max-width: 100%;\n}\n\n/* Dashboard layout */\n.price-returns-dashboard-layout {\n  max-width: 1880px;\n  margin: 0 auto;\n  background: white;\n  border-radius: 0;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: none;\n  display: flex;\n  gap: 10px;\n  height: fit-content;\n}\n\n/* Timeframe selector */\n.price-returns-timeframe-selector {\n  display: flex;\n  margin-bottom: 1.5rem;\n  border-bottom: 1px solid black;\n}\n\n.price-returns-timeframe-button {\n  font-family: 'Roboto Mono', monospace;\n  padding: 0.5rem 1rem;\n  font-weight: 400;\n  font-size: 0.875rem;\n  color: black;\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n\n.price-returns-timeframe-button:hover {\n  color: black;\n}\n\n.price-returns-timeframe-button.price-returns-active {\n  color: black;\n  font-weight: 500;\n  border-bottom: 2px solid black;\n}\n\n/* Chart section */\n.price-returns-chart-section {\n  height: 920px;\n  font-family: 'Roboto Mono', monospace;\n  border: none;\n  box-shadow: none;\n  flex: 1.45;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n  border: 1px black solid;\n}\n\n.price-returns-chart-section h3 {\n  font-size: 1.25rem;\n  font-weight: 400;\n  color: black;\n  margin-bottom: 1rem;\n  text-align:center;\n}\n\n/* Summary section */\n.price-returns-summary-section {\n  padding-top: 0px;\n  padding-right: 10px;\n  padding-bottom: 40px;\n  overflow: visible;\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  height: 920px;\n}\n\n.price-returns-summary-table-container {\n  flex: 1;\n  overflow-y: hidden;\n  min-height: 0;\n  background: white;\n  box-shadow: none;\n  outline: 0.25px solid black;\n  border: none;\n  height: 920px;\n}\n\n.price-returns-summary-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: 'Roboto Mono', monospace;\n  font-size: 0.85rem;\n}\n\n.price-returns-summary-table thead {\n  position: sticky;\n  top: 0;\n  background: white;\n  z-index: 1;\n}\n\n.price-returns-summary-table th {\n  padding: 0.5rem 1rem;\n  text-align: left;\n  font-size: 0.85rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: black;\n  background-color: white;\n  border-bottom: 1px solid black;\n}\n\n.price-returns-summary-table td {\n  padding: 0.5rem 1rem;\n  white-space: nowrap;\n  font-size: 0.85rem;\n}\n\n.price-returns-summary-table th:first-child,\n.price-returns-summary-table td:first-child {\n  text-align: left;\n  color: black;\n  font-weight: 400;\n  border-right: 1px solid black;\n}\n\n.price-returns-summary-table td {\n  transition: background-color 0.2s ease;\n}\n\n.price-returns-summary-table td.price-returns-positive {\n  color: #28a745;\n  background-color: rgba(40, 167, 69, 0.1);\n}\n\n.price-returns-summary-table td.price-returns-negative {\n  color: #dc3545;\n  background-color: rgba(220, 53, 69, 0.1);\n}\n\n.price-returns-summary-table td.price-returns-active {\n  font-weight: 400;\n}\n\n.price-returns-summary-table tbody tr:hover td.price-returns-positive {\n  background-color: rgba(40, 167, 69, 0.1);\n}\n\n.price-returns-summary-table tbody tr:hover td.price-returns-negative {\n  background-color: rgba(220, 53, 69, 0.1);\n}\n\n/* Sector tables */\n.price-returns-sector-tables {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 1.5rem;\n  padding: 1.5rem 0;\n}\n\n.price-returns-sector-table {\n  background: white;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  padding: 1.25rem;\n  border: 1px solid black;\n  font-family: 'Roboto Mono', monospace;\n}\n\n.price-returns-sector-table h3 {\n  font-size: 1rem;\n  font-weight: 400;\n  color: #1f2937;\n  margin-bottom: 0.75rem;\n  text-align: center;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.price-returns-returns-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n}\n\n.price-returns-returns-table th,\n.price-returns-returns-table td {\n  padding: 6px 8px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n  font-size: 0.813rem;\n}\n\n.price-returns-returns-table th {\n  color: black;\n  font-weight: normal;\n  background-color: #f8f9fa;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.price-returns-returns-table th:hover {\n  background-color: #e9ecef;\n}\n\n.price-returns-returns-table tr:hover:not(.price-returns-category-total) {\n  background-color: #f8f9fa;\n}\n\n/* Utility classes */\n.price-returns-positive {\n  color: #28a745;\n}\n\n.price-returns-negative {\n  color: #dc3545;\n}\n\n.price-returns-category-total {\n  font-weight: 600;\n  background-color: #f8f9fa;\n}\n\n.price-returns-sort-indicator {\n  display: inline-block;\n  margin-left: 4px;\n  font-size: 12px;\n}\n\n/* Loading and error states */\n.price-returns-loading,\n.price-returns-error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  font-size: 18px;\n}\n\n.price-returns-loading {\n  color: #666;\n}\n\n.price-returns-error {\n  color: #dc3545;\n}\n\n/* Chart styles */\n.price-returns-dashboard .recharts-cartesian-grid line {\n  stroke: #eee;\n}\n\n.price-returns-dashboard .recharts-text {\n  font-family: 'Roboto Mono', monospace;\n  font-size: 12px;\n  fill: black;\n}\n\n.price-returns-dashboard .recharts-responsive-container {\n  width: 100% !important;\n  height: 100% !important;\n  overflow: visible !important;\n}\n\n/* Responsive */\n@media (max-width: 1200px) {\n  .price-returns-dashboard-layout {\n    flex-direction: column;\n  }\n  \n  .price-returns-chart-section,\n  .price-returns-summary-section {\n    width: 100%;\n    min-height: 300px;\n  }\n}\n\n@media (max-width: 768px) {\n  .price-returns-sector-tables {\n    grid-template-columns: 1fr;\n  }\n}\n\n.price-returns-logo-link {\n  text-decoration: none;\n  margin-left: 0;  /* Ensure no left margin */\n  padding-left: 0; /* Ensure no left padding */\n}\n\n.price-returns-logo.asxn-logo {\n  text-align: left;  /* Ensure left alignment */\n  margin-left: 0;    /* Remove any margin */\n  padding-left: 0;   /* Remove any padding */\n}\n\n/* Last Updated Time */\n.price-returns-last-updated {\n  text-align: center;\n  color: #888;\n  font-size: 0.8rem;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
